import { companySizeList, employerRoleList } from '../../../../configs/signUp';
import PhoneNumberInput from '../../../../components/PhoneNumberInput';
import { useDispatch, useSelector } from '../../../../store/store';
import MotionWrapper from '../../../../layouts/MotionWrapper';
import DropDown from '../../../../components/DropDown';
import Button from '../../../../components/Button';
import Input from '../../../../components/Input';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import {
    City,
    Country,
    ListItem,
    CountryState,
} from '../../../../store/general/types';
import {
    setEmployerInfo,
    setUserPhoneNumber,
} from '../../../../store/signUp/slice';
import {
    getStatesThunk,
    getCitiesThunk,
    getCountriesThunk,
} from '../../../../store/general/thunks';
import {
    selectEditMode,
    selectFetchStatus,
    selectEmployerInfo,
    selectUserId,
    selectEmail,
    selectPhoneNumber,
    selectDisablePhoneNumber,
} from '../../../../store/signUp/selectors';
import {
    selectStates,
    selectCities,
    selectCountries,
} from '../../../../store/general/selectors';
import { updateUserAttributesThunk } from '../../../../store/signUp/thunks';
import { TypographyLogo } from '../../../../assets/icons';

function EmployerInfo() {
    const dispatch = useDispatch();
    const email = useSelector(selectEmail);
    const userId = useSelector(selectUserId);
    const cities = useSelector(selectCities);
    const states = useSelector(selectStates);
    const editMode = useSelector(selectEditMode);
    const countries = useSelector(selectCountries);
    const fetchStatus = useSelector(selectFetchStatus);
    const employerInfo = useSelector(selectEmployerInfo);
    const storePhoneNumber = useSelector(selectPhoneNumber);
    const [city, setCity] = useState(employerInfo?.city || '');
    const [state, setState] = useState(employerInfo?.state || '');
    const disablePhoneNumber = useSelector(selectDisablePhoneNumber);
    const [country, setCountry] = useState(employerInfo?.country || '');
    const [address, setAddress] = useState(employerInfo?.address || '');
    const [zipCode, setZipCode] = useState(employerInfo?.zipCode || '');
    const [lastName, setLastName] = useState(employerInfo?.lastName || '');
    const [firstName, setFirstName] = useState(employerInfo?.firstName || '');
    const [companyName, setCompanyName] = useState(employerInfo?.companyName || '');
    const [companyWebsite, setCompanyWebsite] = useState(employerInfo?.companyWebsite || '');
    const [role, setRole] = useState<ListItem>(employerInfo?.employerRole || { title: '', id: '-1' });
    const [companySize, setCompanySize] = useState<ListItem | null>(employerInfo?.companySize || null);
    const [phoneNumber, setPhoneNumber] = useState<string | undefined>(employerInfo?.phoneNumber || storePhoneNumber);
    const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);

    const [isValidURL, setIsValidURL] = useState(true);
    const [isValidFirstName, setIsValidFirstName] = useState(true);
    const [isValidLastName, setIsValidLastName] = useState(true);
    const [isValidCoName, setIsValidCoName] = useState(true);
    const [isValidCity, setIsValidCity] = useState(true);
    const [isValidState, setIsValidState] = useState(true);
    const [isValidCoSize, setIsValidCoSize] = useState(true);
    const [isValidCountry, setIsValidCountry] = useState(true);
    const [isValidAddress, setIsValidAddress] = useState(true);
    const [isValidZipCode, setIsValidZipCode] = useState(true);
    const [isValidRole, setIsValidRole] = useState(true);


    useEffect(() => {
        dispatch(getCountriesThunk());
        dispatch(getStatesThunk());
    }, []);

    useEffect(() => {
        city.length > 1 && dispatch(getCitiesThunk(city));
    }, [city])

    const next = () => {
        if (!userId || (phoneNumber && !isValidPhoneNumber) || !lastName || !address || !zipCode || !state ||
            !city || !role.title || !companyName || !companySize || !companyWebsite || !firstName || !country) {

            !city ? setIsValidCity(false) : setIsValidCity(true);
            !state ? setIsValidState(false) : setIsValidState(true);
            !role.title ? setIsValidRole(false) : setIsValidRole(true);
            !companyWebsite ? setIsValidURL(false) : setIsValidURL(true);
            !country ? setIsValidCountry(false) : setIsValidCountry(true);
            !address ? setIsValidAddress(false) : setIsValidAddress(true);
            !zipCode ? setIsValidZipCode(false) : setIsValidZipCode(true);
            !companyName ? setIsValidCoName(false) : setIsValidCoName(true);
            !companySize ? setIsValidCoSize(false) : setIsValidCoSize(true);
            !lastName ? setIsValidLastName(false) : setIsValidLastName(true);
            !firstName ? setIsValidFirstName(false) : setIsValidFirstName(true);

            return;
        }

        setIsValidCity(true);
        setIsValidState(true);
        setIsValidRole(true);
        setIsValidURL(true);
        setIsValidCountry(true);
        setIsValidAddress(true);
        setIsValidZipCode(true);
        setIsValidCoName(true);
        setIsValidCoSize(true);
        setIsValidLastName(true);
        setIsValidFirstName(true);

        const info = {
            city,
            state,
            email,
            country,
            address,
            zipCode,
            lastName,
            firstName,
            id: userId,
            companySize,
            companyName,
            companyWebsite,
            employerRole: role,
            phoneNumber: phoneNumber || '',
        };

        dispatch(setEmployerInfo(info));
        dispatch(setUserPhoneNumber(phoneNumber || ''));
        dispatch(updateUserAttributesThunk(info));
    };

    const setCityAndState = (city: City) => {
        setCity(city.city);
        const state = states.find(state => `${state.id}` === city.state_id);
        state && setState(state.state);
        setCountry('United States');
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <div className={styles.head}>
                <TypographyLogo />
                <span className={styles.head_devider} />
                <span className={styles.head_title}>Sign Up</span>
            </div>
            <span className={styles.description}>
                Please complete the form to sign up:
            </span>
            <div className={styles.form}>
                <div className={styles.form_row}>
                    <Input
                        isRequired
                        hasError={!isValidFirstName}
                        label='Legal first name'
                        type='text'
                        placeholder=''
                        value={firstName}
                        onChange={setFirstName}
                    />
                    <Input
                        isRequired
                        hasError={!isValidLastName}
                        label='Legal last name'
                        type='text'
                        placeholder=''
                        value={lastName}
                        onChange={setLastName}
                    />
                </div>
                <div className={styles.form_row}>
                    <PhoneNumberInput
                        label='Phone number (optional)'
                        showErrorMessage
                        phoneNumber={phoneNumber}
                        disabled={disablePhoneNumber}
                        setPhoneNumber={setPhoneNumber}
                        setIsValid={setIsValidPhoneNumber}
                    />
                    <Input
                        isRequired
                        hasError={!isValidCoName}
                        label='Company name'
                        type='text'
                        placeholder=''
                        value={companyName}
                        onChange={setCompanyName}
                    />
                </div>
                <div className={styles.form_row}>
                    <DropDown
                        isRequired
                        label='Company size'
                        hasError={!isValidCoSize}
                        dropDownList={companySizeList}
                        selectedItem={companySize}
                        setItem={setCompanySize}
                        titleKey='title'
                        idKey='id'
                    />
                    <Input
                        isRequired
                        hasError={!isValidURL}
                        label='Company website URL'
                        type='text'
                        validation='URL'
                        placeholder=''
                        value={companyWebsite}
                        onChange={setCompanyWebsite}
                    />
                </div>
                <div className={styles.form_row}>
                    <Input
                        isRequired
                        type='text'
                        label='Company address'
                        placeholder=''
                        value={address}
                        hasError={!isValidAddress}
                        onChange={setAddress}
                    />
                    <Input
                        isRequired
                        listShow
                        label='City'
                        type='text'
                        value={city}
                        list={cities}
                        placeholder=''
                        listIdKey='id'
                        hasError={!isValidCity}
                        onChange={setCity}
                        listTitleKey='city'
                        listTitleSuffixKey='state_code'
                        onItemClick={(item: City) => setCityAndState(item)}
                    />
                </div>
                <div className={styles.form_row}>
                    <Input
                        isRequired
                        listShow
                        type='text'
                        placeholder=''
                        listIdKey='id'
                        label='Country'
                        value={country}
                        hasError={!isValidCountry}
                        listTitleKey='title'
                        onChange={setCountry}
                        onItemClick={(item: Country) => setCountry(item.title)}
                        list={countries.filter(i => i.title.toLowerCase().startsWith(country.toLowerCase()))}
                    />
                    <Input
                        isRequired
                        listShow
                        type='text'
                        label='State'
                        value={state}
                        placeholder=''
                        listIdKey='id'
                        hasError={!isValidState}
                        listTitleKey='state'
                        onChange={setState}
                        wrapperClassName={styles.state_zip_state}
                        onItemClick={(item: CountryState) => setState(item.state)}
                        list={states.filter(i => i.state.toLowerCase().startsWith(state.toLowerCase()))}
                    />
                </div>
                <div className={styles.form_row}>
                    <Input
                        isRequired
                        type='text'
                        label='Zip Code'
                        placeholder=''
                        value={zipCode}
                        hasError={!isValidZipCode}
                        onChange={setZipCode}
                        wrapperClassName={styles.state_zip_zipCode}
                    />
                    <Input
                        isRequired
                        listShow
                        label='Your role'
                        type='text'
                        placeholder=''
                        value={role.title}
                        listIdKey='id'
                        listTitleKey='title'
                        hasError={!isValidRole}
                        list={employerRoleList}
                        onItemClick={(item: ListItem) => setRole(item)}
                        onChange={(val: string) => setRole({ id: '-1', title: val })}
                    />
                </div>
                <Button
                    onClick={next}
                    className={styles.next}
                    text={editMode ? 'Save' : 'Next'}
                    loading={fetchStatus === 'Pending'}
                />
            </div>
        </MotionWrapper>
    );
};

export default EmployerInfo;

{/* <Input
                disabled
                label='Email'
                type='email'
                validation='Email'
                onChange={setEmail}
                value={storeEmail || email}
                placeholder=''
            /> */}